// extracted by mini-css-extract-plugin
module.exports = {"description":"FeatureDescription-module--description--1WOy4"};